import { useState } from 'react';
import { fetchTaxingUnitPollQuestions } from '../../api/questions';
import FeedbackPanel from '../_components/feedbackPanel';
import AssessmentTab from './AssessmentTab';
import ContactDetailTab from './ContactDetailTab';
import Tab from './Tab';

const ASSESSMENT_TAB = 'Assessment';
const CONTACT_TAB = 'Contact Details';
const FEEDBACK_TAB = 'Feedback';
const tabs = [ASSESSMENT_TAB, CONTACT_TAB, FEEDBACK_TAB];

const PIDUnitWrapper = ({
  assessment,
  fetchTaxingUnit,
  showBudgetInformation,
  openWorksheetPDF,
  taxpayerFeedbackEnabled,
  captchaKey,
  apiBaseUrl,
  token,
  submitFeedack,
  pushToast,
  params,
  year,
}) => {
  const [currentTab, setCurrentTab] = useState(0);

  // Create a unit-like object for ContactDetailTab compatibility
  const unitForContact = {
    taxingUnitID: assessment.taxingUnitID,
    taxingUnitCode: assessment.taxingUnitCode,
    taxingUnitName: assessment.taxingUnitName,
  };

  // Use assessment.taxYear if available, otherwise fall back to currentYear
  // Ensure we have a valid year value (not null or undefined)
  const assessmentYear = assessment.taxYear != null ? assessment.taxYear : year;

  const renderContent = (tab) => {
    switch (tab) {
      case ASSESSMENT_TAB:
        return <AssessmentTab assessment={assessment} />;
      case CONTACT_TAB:
        return (
          <ContactDetailTab
            fetchTaxingUnit={fetchTaxingUnit}
            openWorksheetPDF={openWorksheetPDF}
            showBudgetInformation={showBudgetInformation}
            unit={unitForContact}
            isPID={true}
          />
        );
      case FEEDBACK_TAB:
        return taxpayerFeedbackEnabled && assessmentYear != null ? (
          <FeedbackPanel
            captchaKey={captchaKey}
            fetchTaxingUnitPollQuestions={fetchTaxingUnitPollQuestions.bind(
              null,
              apiBaseUrl,
              token,
            )}
            handleSubmit={(data) =>
              submitFeedack({
                ...data,
                selectedUnitId: assessment.taxingUnitID,
                selectedUnitYear: assessmentYear,
                selectedProperty: params.propertyId,
              })
            }
            pushToast={pushToast}
            unitId={assessment.taxingUnitID}
            year={String(assessmentYear)}
          />
        ) : null;
      default:
        return null;
    }
  };

  return (
    <div className='custom-container'>
      <div className='title'>
        <span>{assessment.taxingUnitName}</span>
        <span className='taxing-code'>
          PID Assessment Code: {assessment.taxingUnitCode}
        </span>
      </div>
      <div className='tax-wrapper'>
        <Tab
          currentTab={currentTab}
          renderContent={renderContent}
          setCurrentTab={(tab) => setCurrentTab(tab)}
          tabs={tabs}
        />
      </div>
    </div>
  );
};

export default PIDUnitWrapper;
